import { createContext } from "react"
import { FormGroup } from "components/TemplateEditor/VariablePill"

export type MergeTagEditorContextType = {
  groupedForms: FormGroup[]
  onSave?: () => void
  subjectLineMode?: boolean
}

export const MergeTagEditorContext = createContext<MergeTagEditorContextType>({
  groupedForms: [],
  subjectLineMode: false,
})

/** @deprecated Use MergeTagEditorContext */
export type SMSEditorContextType = MergeTagEditorContextType

/** @deprecated Use MergeTagEditorContext */
export const SMSEditorContext = MergeTagEditorContext
